<template>
	<el-container>
		<el-scrollbar>
			<el-header class="header-top" style="height: 50px;">
				<s-header-top></s-header-top>
			</el-header>
			<el-header class="header">
				<s-header></s-header>
			</el-header>
			<el-main>
				<div class="content">
					<el-row type="flex" justify="space-between">
						<el-col :span="12">
							<el-breadcrumb separator-class="el-icon-arrow-right">
								<span style="float: left;">当前位置：</span>
								<el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
								<el-breadcrumb-item :to="{ path: '/release' }">发布需求</el-breadcrumb-item>
							</el-breadcrumb>
						</el-col>
					</el-row>
					<div class="page">
						<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="release-form">
						  <el-form-item label="需求标题" >
						    <el-input v-model="ruleForm.title"></el-input>
						  </el-form-item>
						  <el-form-item label="需求分类" prop="requstType">
						    <el-select v-model="ruleForm.requstType" placeholder="请选择活动区域">
								<el-option v-for="(item, index) in requstTypeOption" :key="index" :label="item" :value="item"></el-option>
						    </el-select>
						  </el-form-item>
						  <el-form-item label="我的需求">
						    <el-input type="textarea" v-model="ruleForm.requestContent"></el-input>
						  </el-form-item>
						  <el-form-item label="预算金额">
						    <el-col :span="20">
						      <el-form-item prop="planMoney">
						        <el-input v-model="ruleForm.planMoney"></el-input>
						      </el-form-item>
						    </el-col>
						    <el-col class="line" :span="4">万元整</el-col>
						  </el-form-item>
						  <el-form-item label="联系电话" prop="connectPhone">
							<el-input v-model="ruleForm.connectPhone"></el-input>
						  </el-form-item>
						  <el-form-item label="客户要求">
						    <el-radio-group v-model="ruleForm.connectType">
						      <el-radio label="1">需求方主动联系供应方</el-radio>
						      <el-radio label="2">供应方主动联系需求方</el-radio>
						    </el-radio-group>
						  </el-form-item>
						  <div class="release-form-buttons">
						    <el-button style="margin-right: 70px;" @click="goIndex()">返回</el-button>
						    <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
						  </div>
						</el-form>
					</div>
				</div>
			</el-main>
			<el-footer class="footer">
				<s-footer></s-footer>
			</el-footer>
			<el-footer class="copy-right">
				<s-copyRight></s-copyRight>
			</el-footer>
		</el-scrollbar>
	</el-container>	
</template>

<script>
import sHeaderTop from '@/components/header_top';
import sHeader from '@/components/header'
import sFooter from '@/components/footer';
import sCopyRight from '@/components/copy-right';
import { myRequests } from '@/api';
export default {
	name: 'release',
	components:{
		sHeaderTop,
		sHeader,
		sFooter,
		sCopyRight,
	},
	data () {
		var validateTel = (rule, value, callback) => {
			if (!value) {
			  return callback(new Error('手机号不能为空'));
			} else  if (!/^1(3|4|5|6|7|8)\d{9}$/.test(value)) {
				return callback(new Error('请输入正确的手机号'));
			} else {
				callback();
			}
		};
		var validateMoney = (rule, value, callback) => {
			if (!/^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/.test(value)) {
				return callback(new Error('请输入正确的金额'));
			} else {
				callback();
			}
		};
		return {
			requstTypeOption:['经营场地','证照代办','人才招培','项目申报','融资对接','技术需求','成果转化','其他咨询'],
			ruleForm:{
				title: '',//标题
				requstType: '',//需求分类
				requestContent:'',//我的需求
				planMoney:'00.01',//预算金额
				connectPhone: '' ,//联系电话
				connectType:'1'//客户要求
			},
			rules: {
				requstType: [
					{ required: true, message: '请选择需求分类', trigger: 'change' }
				],
				connectPhone: [
					{ required: true,validator: validateTel, trigger: 'blur' }
				],	
				planMoney:[
					{ validator: validateMoney, trigger: 'blur' }
				]
			}
		}
	},
	methods: {
		submitForm(formName) {
			let _this = this
			_this.$refs[formName].validate((valid) => {
			  if (valid) {
				myRequests(_this.ruleForm).then(res=> {
					if (res.code == 0) {
						_this.$confirm('发布成功，继续发布, 还是返回首页?', '提示', {
						  confirmButtonText: '返回首页',
						  cancelButtonText: '继续发布',
						  type: 'success'
						}).then(() => {
						  _this.goIndex()
						}).catch(() => {
						});
					}
				})
			  } else {
				return false;
			  }
			});
		},
		//返回到首页
		goIndex(){
			this.$router.push({path:'/index'})
		}
	}
}
</script>


<style lang="scss">
.release-form{
	width: 90%;
	margin:0 auto;
	
	.release-form-buttons{
		display: flex;flex-direction: row;justify-content: center;
		.el-button{
			width: 200px;
		}
	}
	
	/deep/.el-form-item__label{
		font-size: 16px;
	}
}
</style>
<style lang="scss" scoped>
.page{	
	min-height: 618px; /*若没有tabs56  height524 若有height468 */
}
</style>



// WEBPACK FOOTER //
// src/views/release.vue